import { getBaseURL } from '../utils/S3Utils';
import Label from './Label';
const labels: Label[] = [
  {
    id: 'beatflyer',
    name: 'Beatflyer'
  },
  {
    id: 'fine-day',
    name: 'Fine Day Records',
    thumbnail: '${S3}/loops/fine-day/thumb.jpg',
    bio: 'Fine Day Records is a Philadelphia based music label founded by Plastic Operator member Mathieu Gendreau. Our European distribution is handled by Rough Trade Benelux. P-Vine Records distributes the Plastic Operator albums in Japan.',
    websiteURL: 'https://finedayrecords.com/',
    buyURL: 'https://www.beatport.com/label/fine-day-records/5775',
    bookURL: 'mailto:info@finedayrecords.com',
    facebookURL: 'https://www.facebook.com/Fine-Day-Records-263086757071853/',
    instagramURL: 'https://www.instagram.com/finedayrecords/',
    twitterURL: 'https://twitter.com/finedayrecords',
    soundcloudURL: 'https://soundcloud.com/finedayrecords',
    youtubeURL: 'https://www.youtube.com/user/FineDayRecords'
  },
  {
    id: 'krkr',
    name: 'KRKR Records',
    thumbnail: '${S3}/loops/krkr/thumb.jpg',
    bio: 'Newly born Milan based imprint focussing on deep-tech, minimal and tech house. We are looking to promote high quality underground music and remain open to innovation.\n\nWe are a network of like minded producers and DJs with a wide range of influences spanning from dub to techno to ambient and experimental music.',
    websiteURL: 'https://www.beatport.com/label/krkr/46560',
    buyURL: 'https://www.beatport.com/label/krkr/46560',
    bookURL: 'mailto:info@krkrecords.com',
    facebookURL: 'https://www.facebook.com/krkr.records/',
    soundcloudURL: 'https://soundcloud.com/krkr-records'
  },
  {
    id: 'magic-beatz',
    name: 'Magic Beatz',
    thumbnail: '${S3}/loops/magic-beatz/thumb.png',
    bio: 'Coming soon...',
    buyURL: 'https://www.beatport.com/label/magic-beatz/62461',
    bookURL: 'mailto:magicbeatzrecords@gmail.com',
    facebookURL: 'https://www.facebook.com/magicbeatz.recordings',
    instagramURL: 'https://www.instagram.com/magicbeatzrecordings/',
    soundcloudURL: 'https://soundcloud.com/magicbeatzrecords'
  },
  {
    id: 'parasol',
    name: 'Parasol Culture',
    thumbnail: '${S3}/loops/parasol/thumb.jpg',
    bio: 'A vinyl only imprint started by @ThomaBulwer focusing on quality house music, with a tinge of "it\'s a London thing”.\n\nPARACULT002 out 1st July 2018\n\nPARACULT001 out now in all record stores.',
    websiteURL: 'https://www.parasolculture.com',
    buyURL: 'https://www.juno.co.uk/labels/Parasol+Culture/',
    bookURL: 'mailto:getaholdoftom@gmail.com',
    facebookURL: 'https://www.facebook.com/parasolculturerecords/',
    instagramURL: 'https://www.instagram.com/thomabulwer',
    soundcloudURL: 'https://soundcloud.com/user-904640178-708243366'
  },
  {
    id: 'native-soul',
    name: 'Native Soul',
    thumbnail: '${S3}/loops/native-soul/thumb.png',
    bio: `Native Soul Recordings is an American digital label founded in the early 2000s by Bobby and his partners Dominic and Herman. The label has become a prominent force in the House Music scene, featuring artists from all over the world and showcasing their unique sounds. Native Soul Recordings has gained a loyal following of fans and colleagues who support the label's efforts to promote dance and freedom through music. With numerous successful releases under their belt, Native Soul Recordings is considered one of America's top House Music labels and continues to thrive in the digital age of music.`,
    websiteURL: 'https://nativesoulrecordings.com',
    soundcloudURL: 'https://soundcloud.com/native-soul-recordings',
    facebookURL: 'https://www.facebook.com/profile.php?id=100063313954380',
    buyURL: 'https://nativesoulrecordings.bandcamp.com'
  }
];

export default JSON.parse(
  JSON.stringify(labels).split('${S3}/').join(getBaseURL())
) as Label[];



// WEBPACK FOOTER //
// ./src/audio-editing/labels.ts